import { withInstall } from '@haohan/clw-utils'
import ChainComparison from './HHChainComparison.vue'
export const HHChainComparison = withInstall(ChainComparison)
export default HHChainComparison
